<div class="modal-body">
  <app-manage-payment-methods (paymentMethod)="processPayment($event)" *ngIf="!promptPaymentConfirmation"></app-manage-payment-methods>
  <app-confirm-payment *ngIf="promptPaymentConfirmation" [paymentMethodd]="selectedPaymentMethod"></app-confirm-payment>
</div>